export type CounterTypes = "standard" | "extended" | "tc-back"
/*   | "baksida"
  | "framsida"
  | "framsida-baksida" */

export type CounterObject = {
  type: CounterTypes
  [key: string]: any
}

export const StandardCounter = {
  type: "standard",
  fliers: 0,
  ths: 0,
}

export const ExtendedCounter = {
  type: "extended",
  ths: 0,
  externs: 0,
}

export const TCBackCounter = {
  type: "tc-back",
  inside: 0,
  outside: 0,
}

export const CounterTypeMap: Record<CounterTypes, object> = {
  standard: StandardCounter,
  extended: ExtendedCounter,
  "tc-back": TCBackCounter,
}
